import React, { useState, useEffect } from 'react';
import '../../assets/css/common.css';
import '../../assets/css/main.css';
import '../../assets/css/adm_custom.css';
import { openAlert, DOC_KIND } from '../../utils/common';
import SectionContainer from '../../components/UI/SectionContainer';
import Spinner from '../../components/UI/Spinner';
import termsService from '../../services/termsService';

const PrivacyPage = () => {
  const [lang, setLang] = useState('ko');
  const [contentKo, setContentKo] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPrivacy = async () => {
      setLoading(true);
      try {
        const result = await termsService.getTerms(DOC_KIND.PRIVACY);
        setContentKo(result.contentKo);
        setContentEn(result.contentEn);
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '데이터 로드 중 오류가 발생했습니다.';
        openAlert({ title: '알림', description: errorMessage });
      } finally {
        setLoading(false);
      }
    };
    fetchPrivacy();
  }, []);

  const handleSave = async () => {
    if (!window.confirm('개인정보처리방침을 변경하면 이전에 동의한 회원은 재동의가 필요합니다. 저장하시겠습니까?')) return;
    setLoading(true);
    try {
      const result = await termsService.updateTerms(DOC_KIND.PRIVACY, contentKo, contentEn);
      openAlert({ title: '알림', description: result.message });
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '저장 중 오류가 발생했습니다.';
      openAlert({ title: '알림', description: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SectionContainer title="개인정보 처리방침 등록">
      <Spinner visible={loading} />
      <div className="content_area">
        <div className="notice">
          <div className="lang_tab_area">
            <div
              className={`lang_tab ${lang === "ko" ? "active" : ""}`}
              onClick={() => setLang("ko")}
            >
              한국어
            </div>
            <div
              className={`lang_tab ${lang === "en" ? "active" : ""}`}
              onClick={() => setLang("en")}
            >
              English
            </div>
          </div>
          <div className="notice_area">
            <div className="modal-content-wrap">
              {lang === "ko" && (
                <div className="lang_content active" id="ko_content">
                  <textarea
                    style={{ resize: "none", height: "550px" }}
                    id="content_ko"
                    value={contentKo}
                    onChange={(e) => setContentKo(e.target.value)}
                    placeholder="한국어 내용을 입력해주세요."
                    maxLength={50000}
                  />
                  <div className="text-muted small mt-1">
                    {contentKo.length}/50000자
                  </div>
                </div>
              )}
              {lang === "en" && (
                <div className="lang_content active" id="en_content">
                  <textarea
                    style={{ resize: "none", height: "550px" }}
                    id="content_en"
                    value={contentEn}
                    onChange={(e) => setContentEn(e.target.value)}
                    placeholder="Please enter content in English."
                    maxLength={50000}
                  />
                  <div className="text-muted small mt-1">
                    {contentEn.length}/50000자
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="notice_btn">
            <div className="add_btn" onClick={handleSave}>
              {loading ? "저장중..." : "저장하기"}
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default PrivacyPage;
